function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpTo2Kg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 0.666687H5.33337C4.00729 0.666687 2.73552 1.19347 1.79784 2.13115C0.860158 3.06884 0.333374 4.3406 0.333374 5.66669V22.3334C0.333374 23.6594 0.860158 24.9312 1.79784 25.8689C2.73552 26.8066 4.00729 27.3334 5.33337 27.3334H28.6667C29.9928 27.3334 31.2646 26.8066 32.2022 25.8689C33.1399 24.9312 33.6667 23.6594 33.6667 22.3334V5.66669C33.6667 4.3406 33.1399 3.06884 32.2022 2.13115C31.2646 1.19347 29.9928 0.666687 28.6667 0.666687ZM27.9834 4.00002L18.1834 13.8C18.0284 13.9562 17.8441 14.0802 17.641 14.1648C17.4379 14.2495 17.2201 14.293 17 14.293C16.78 14.293 16.5622 14.2495 16.3591 14.1648C16.156 14.0802 15.9716 13.9562 15.8167 13.8L6.01671 4.00002H27.9834ZM30.3334 22.3334C30.3334 22.7754 30.1578 23.1993 29.8452 23.5119C29.5327 23.8244 29.1087 24 28.6667 24H5.33337C4.89135 24 4.46742 23.8244 4.15486 23.5119C3.8423 23.1993 3.66671 22.7754 3.66671 22.3334V6.35002L13.4667 16.15C14.4042 17.0864 15.675 17.6123 17 17.6123C18.325 17.6123 19.5959 17.0864 20.5334 16.15L30.3334 6.35002V22.3334Z",
    fill: props.fill
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpTo2Kg);
export default __webpack_public_path__ + "static/media/UpTo2KG.795adecd36e4f3b4b9cc3160c63875a9.svg";
export { ForwardRef as ReactComponent };